import { render, staticRenderFns } from "./DocumentPOSViewCardFinal.vue?vue&type=template&id=254b0688"
import script from "./DocumentPOSViewCardFinal.vue?vue&type=script&lang=js"
export * from "./DocumentPOSViewCardFinal.vue?vue&type=script&lang=js"
import style0 from "./DocumentPOSViewCardFinal.vue?vue&type=style&index=0&id=254b0688&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports